<template>
    <div class="agentWhiteListHolder">
        <div class="errorHolder">
            <div v-if="selectedAgents.length == 0" class="color-6">Select at least one agent</div>
        </div>

        <div class="d-flex mb-1 w-100">
            <input type="text" class="glued-right w-100" v-model="searchString" placeholder="Search agent name">
            <div class="glued-left bg-lighter">
                <i class="ico ico-search m-0 fs-normal color-1"></i>
            </div>
        </div>

        <div class="mb-2 w-100 dark fs-small">
            <span></span> <span class="pointer" @click="selectAll(true)">All</span> | <span class="pointer" @click="selectAll(false)">None</span>
        </div>

        <ul class="agentList">
            <li v-for="agent in allAgents">
                <checkbox v-model="agent.selected" @input="agentSelectedChanged">
                    <span>
                        {{agent.brandName}}
                    </span>
                </checkbox>
            </li>
        </ul>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Loader from '@/tools/loaders/loader1'
export default {
    data: function() {
        return{
            allAgents: [],
            searchString: null,
            originalAgentArr: null,
        }
    },
    props:{
        allowedList:{
            type: Array
        },
        allowedIdArray:{
            type: Array,
            defult: function () {
                return []
            }
        },
        startAllSelected: {
            type: Boolean
        }
    },
    computed: {
        ...mapGetters([
            'account',
            'getAgents',
        ]),
        allowedIdArrayMixed: function () {
            // This computed property works as a layer to convert "allowedList" into "allowedIdArray"
            // this allowes us to receive a list of agents (allowedList) or a list of id's (allowedIdArray)
            if(this.allowedList != undefined){
                return this.allowedList.map(agent => {
                    return agent.id
                })
            } else {
                return this.allowedIdArray
            }
        },
        selectedAgents: function () {
            return this.allAgents.filter(agent => {
                return agent.selected == true
            })
        }
    },
    created: function() {
        this.setLocalAgents()
    },
    methods:{
        setLocalAgents: function () {
            this.$set(this, 'allAgents', JSON.parse(JSON.stringify(this.getAgents)))

            this.allAgents.map(agent => {
                if(this.startAllSelected == true){
                    this.$set(agent, 'selected', true)
                } else {
                    this.$set(agent, 'selected', this.allowedIdArrayMixed.includes(agent.id))
                }
                return agent
            })
        },
        outputUpdated: function(overrideAgenList){
            this.$emit('input', this.allAgents)
        },
        agentSelectedChanged: function() {
            this.outputUpdated()
        },
        selectAll:function(val){
            this.allAgents.map(agent => {
                agent.selected = val
            })
            this.outputUpdated()
        },
    },
    components: {
        Loader
    }
}
</script>

<style lang="scss" scoped>
    .agentWhiteListHolder{

        .errorHolder{
            height: 1.5rem;
        }

        .agentList{
            max-height: 450px;
            overflow: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// AgentWhiteList.vue?e8dbc418